import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  container: {
    marginBottom: 5,
  },
  card: {
    backgroundColor: theme.colors.dark.midnightBlue,
    borderRadius: 15,
  },
  cardContent: {
    paddingTop: '24px !important',
    paddingBottom: '11px !important',
    paddingLeft: '24px !important',
  },
}));

export const useStylesGrid = makeStyles({
  item: { padding: '0 !important' },
});

export const useStylesTypography = makeStyles(theme => ({
  label: {
    fontSize: theme.fonts.sizes.font12PX,
    color: theme.colors.light.lightCyan,
  },
  left: { paddingLeft: 10 },
  right: { paddingRight: 12 },
  main: { fontWeight: 700, marginBottom: 10, color: 'white' },
}));

export const useStylesSlider = makeStyles(theme => ({
  root: {
    '@media(pointer:coarse)': {
      padding: '13px 0',
    },
  },
  rail: {
    height: 6,
    opacity: 1,
    borderRadius: 10,
    backgroundColor: theme.colors.dark.gainsboro,
  },
  track: {
    height: 6,
    opacity: 1,
    borderRadius: 10,
    backgroundImage: `linear-gradient(90deg, ${theme.colors.orange.wheat}, ${theme.colors.orange.orange})`,
  },
  thumb: {
    marginTop: -6,
    width: 18,
    height: 18,
    backgroundColor: theme.colors.dark.gainsboro,
    border: `1px solid ${theme.colors.light.freshPowder}`,
  },
}));
